import React from 'react'
import { Renderhamburgermenu } from "../../hamburger/hamburger-menu";
import { formatDate } from "../../../Utils/format-date.js";
import FakeJson from "../../../Utils/FakeJSONs/submitAssessment.json";
import CompletedAssessmentImg from "../../../../images/new-images/CompletedAssessmentImg.png";
import { Row, Col } from "reactstrap";
import Rendermodals from "../../Modals/modal";
import Renderinviterespondantsmodal from "../Invite-Respondants-Modal/invite-respondants-modal";
import './CompletedAssessment.css'

const ResponsiveCompletedAssessment = (props) => {

  const userName =
    localStorage.getItem("user_name") === "null"
      ? "-"
      : localStorage.getItem("user_name");

  return (
    <div className="Responsive-Completed-Assessment">
      <Renderhamburgermenu
        link1="/new/app/dashBoard"
        link2="/new/app/Invitations"
        text1="Dashboard"
        text2="Invitations"
        reviewMode={props.reviewMode}
      />
      <div style={{ display: "flex", justifyContent: "center" }}>
        <img className="image" src={CompletedAssessmentImg} />
      </div>
      <Row>
        {FakeJson.map((assessment, index) => {
          return (
            <Col key={index}>
              <div>
                <p className="Congratulations">
                  Congratulations, {userName}!
                </p>
                <p className="You-have-completed-your-assessment">
                  You have completed your assessment
                </p>
                <div className="assessment-details">
                  <img
                    className="assessment-Icon"
                    src={
                      localStorage.getItem("baseLink") +
                      `/media/` +
                      assessment.instrument__instrument_image
                    }
                  />
                  <p className="assessment-name">
                    {assessment.instrument__dashboard_header_text}
                  </p>
                </div>
                <p className="userName">
                  <span style={{ marginRight: "5px" }}>
                    {assessment.participant__full_name}'s
                  </span>
                  {assessment.instrument__instrument_name}
                </p>
                <p className="Expiry-date">
                  Completed on {formatDate(Date())}
                </p>
              </div>
              <p className="Now-invite-at-least-3-respondents-and-get-their-feedback ">
                Now, invite at least 3 respondents and get their feedback
              </p>
            </Col>
          );
        })}
      </Row>
      <div style={{ display: "flex", justifyContent: "center", gap: '20px' }}>
        <button
          className="invite-button"
          onClick={props.handleAssessmentSubmit}
        >
          INVITE RESPONDENTS
        </button>
        <button
          className="invite-button"
          onClick={() => window.location.href = '/new/app/dashBoard'}
        >
          SKIP
        </button>



      </div>
      <Rendermodals
        assessmentModal={props.assessmentModal}
        handleModalClose={props.handleModalClose}
        modalHeading="INVITE RESPONDENTS"
        button2="Submit"
      >
        <Renderinviterespondantsmodal
          inputFields={props.inputFields}
          handleInputFields={props.handleInputFields}
          dropDownOptions={props.dropDownOptions}
          handleMultipleEmail={props.handleMultipleEmail}
          isChecked={props.isChecked}
          isDisabled={props.isDisabled}
          handleModalFormSubmit={props.handleModalFormSubmit}
          handleInviteModalSubmit={props.handleInviteModalSubmit}
        />
      </Rendermodals>
    </div>
  );
}

export default ResponsiveCompletedAssessment



// WEBPACK FOOTER //
// ./src/new/Components/CompletedAssessment/Responsive/CompletedAssessment.jsx